/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo } from 'react';

import { Stack } from '@mui/material';

import { useGetTemplateConfig } from 'hooks/api/builder/mapTemplates/useGetTemplateConfig';
import { InteractiveMapConfig } from 'types/builder/componentConfig';

import { MapConfig, MapConfigCreator } from './MapConfigCreator';
import { MapTemplates } from './MapTemplates';
import { MapTemplateCreator } from './MapTemplates/MapTemplateCreator';

type InteractiveMapControlProps = {
    node?: InteractiveMapConfig;
    onChange: (config: InteractiveMapConfig) => void;
};

export const InteractiveMapControl = ({
    onChange,
    node,
}: InteractiveMapControlProps): JSX.Element => {
    const {
        states = [],
        groups = [],
        hidden = [],
        markers = [],
        height = 420,
        markerScale = 1.1,
    } = node?.props || {};

    const onConfigChange = (config: MapConfig): void => {
        onChange({
            component: 'interactiveMap',
            props: {
                ...node?.props,
                ...config,
            },
        });
    };

    const defaultConfig = useMemo(
        () => ({
            groups,
            hidden,
            states,
            markers,
            height,
            markerScale,
        }),
        [groups, height, hidden, markerScale, markers, states]
    );

    const { config, getTemplate } = useGetTemplateConfig();

    useEffect(() => {
        if (config) {
            onChange({
                component: 'interactiveMap',
                props: {
                    ...node?.props,
                    ...config.config,
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [config]);

    return (
        <Stack spacing={2}>
            <MapConfigCreator
                defaultConfig={defaultConfig}
                key={hidden.length + groups.length + states.length}
                onSave={onConfigChange}
            />
            <MapTemplates onSave={(id) => getTemplate(id)} />
            <MapTemplateCreator defaultConfig={defaultConfig} />
        </Stack>
    );
};
